import PageShell from "@/components/PageShell";
import JoinForm from "@/components/join/JoinForm";

export default function Join() {
    return (
        <PageShell testId="join-page">
            <main className="mx-auto max-w-4xl px-5 pb-24 pt-12 md:px-8 md:pt-16">
                <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Join PayMe Online</p>
                <h1 className="mt-2 font-display text-4xl font-bold leading-tight text-primary sm:text-5xl" data-testid="join-title">Join PayMe</h1>
                <p className="mt-5 max-w-2xl text-lg text-foreground/80" data-testid="join-intro">
                    To join PayMe, simply fill out the secure form below. Once we have the contract from your Recruitment Company, we will send you a link so you can set up all your payroll details ready for your first payment.
                </p>
                <div className="mt-10">
                    <JoinForm />
                </div>
            </main>
        </PageShell>
    );
}
